import React from 'react'
import { useTranslation } from "react-i18next";
import cookies from "js-cookie";
import { languages } from "../App";
import btc from "../images/btc.png";
import wd from "../images/wd.png";
import hmp from "../images/hmb.png";
const CompanyWithDeal = () => {
   const { t } = useTranslation();
  const currentLangCode = cookies.get("i18next") || "en";
  const currentLang = languages.find((l) => l.code === currentLangCode);
  return (
    <div>
        <div className=" tw-w-[85%] tw-mx-auto tw-py-20">
         <div className="tw-flex tw-items-center" data-aos="fade-up" data-aos-duration="2000">
          <span className="tw-h-[2px] tw-bg-one-gold tw-w-[40px] "></span>
          <span className=" tw-capitalize tw-text-3xl tw-font-bold tw-text-one-gold tw-p-5 sm:tw-p-3 tw-whitespace-nowrap sm:tw-text-2xl">
            {t("company_with_deal")}
          </span>
        </div>
         <div className="tw-grid tw-grid-cols-3 sm:tw-grid-cols-1 tw-items-center tw-flex-1 tw-p-7 tw-gap-1" data-aos="fade-down" data-aos-duration="2000">
            <div
              className="tw-p-3 tw-shadow-sm tw-border tw-rounded-md tw-border-gray-100 hover:tw-shadow-lg tw-cursor-pointer tw-flex tw-justify-center tw-h-[150px] tw-duration-500"
            >
                {/* <div>
                    <p>برنامج المسابقات الشهير من يكسب المليون بدأ بثه 1998 الى اليوم وتم عرضه في اكثر من خمسين دولة  حول العالم</p>
                </div> */}
              <img
                src={wd}
                loading="lazy"
                alt="img"
                className=" tw-w-40 md:tw-w-[120px] sm:tw-w-[100px] xs:tw-w-[90px] tw-rounded-md tw-object-contain"
              />
            </div>
            <div className="tw-p-1 tw-shadow-sm tw-border tw-rounded-md tw-border-gray-100 hover:tw-shadow-lg tw-cursor-pointer tw-flex tw-justify-center tw-h-[150px] tw-duration-500"
            >
              <img
                src={btc}
                loading="lazy"
                alt="img"
                className=" tw-w-40 md:tw-w-[120px] sm:tw-w-[100px] xs:tw-w-[90px] tw-rounded-md tw-object-contain"
              />
            </div>
            <div className="tw-p-1 tw-shadow-sm tw-border tw-rounded-md tw-border-gray-100 hover:tw-shadow-lg tw-cursor-pointer tw-flex tw-justify-center tw-h-[150px] tw-duration-500"
            >
              <img
                src={hmp}
                loading="lazy"
                alt="img"
                className=" tw-w-40 md:tw-w-[120px] sm:tw-w-[100px] xs:tw-w-[90px] tw-rounded-md tw-object-contain"
              />
            </div>
          </div>
          </div>
    </div>
  )
}

export default CompanyWithDeal